import PropTypes from "prop-types";

import { FlexContainers, WrapperContainer } from "../../components";
import { FormSectionWrapper, InfoText, Title } from "./styled";

const FormSection = ({ title, infoText, children, Component }) => {
  return (
    <FormSectionWrapper>
      <WrapperContainer Container={FlexContainers.FlexRowBetween} width={"100%"} mb={24}>
        <WrapperContainer Container={FlexContainers.FlexRowStart} width={"100%"} gap={8}>
          <Title>{title}</Title>
          {Component && Component}
        </WrapperContainer>

        {infoText && <InfoText>{infoText}</InfoText>}
      </WrapperContainer>

      {children}
    </FormSectionWrapper>
  );
};

FormSection.propTypes = {
  title: PropTypes.string.isRequired,
  infoText: PropTypes.string,
  children: PropTypes.node.isRequired,
  Component: PropTypes.node
};
export default FormSection;
